import isServer from '@hydra/utils/isServer';

export default () => {
  if (!isServer()) {
    try {
      return window.location !== window.parent.location;
    } catch (err) {
      return null;
    }
  }
  return null;
};
